import { Chip } from '@scale/scaleui';
import { Attachment } from '@scale/shared/types/chat';
import { useState } from 'react';
import ShowAttachmentModal from 'react-scale/components/scalers/tasks/ThreadedInteraction/attachments/ShowAttachmentModal';

type AttachmentChipProps = {
  attachment: Attachment;
  deleteAttachment: () => void;
  readOnly?: boolean;
};

const AttachmentChip = ({ attachment, deleteAttachment, readOnly }: AttachmentChipProps) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  return (
    <>
      <Chip
        label={attachment.name.slice(0, 50) + (attachment.name.length > 50 ? '...' : '')}
        leadingIcon="paperclip"
        className="cursor-pointer"
        onClick={() => {
          setShowModal(true);
        }}
        onDismiss={
          readOnly
            ? undefined
            : () => {
                deleteAttachment();
              }
        }
      />
      <ShowAttachmentModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        attachment={attachment}
      />
    </>
  );
};

export default AttachmentChip;
